import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import { NavLink } from 'react-router-dom';

export interface AppMenuItemComponentProps {
    customClassName?: string;
    path?: string | null; // because the InferProps props allows alows null value
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const AppMenuItemComponent: React.FC<AppMenuItemComponentProps> = (props) => {
    const { customClassName, onClick, path, children } = props;

    // If link is not set return the orinary ListItem
    if (!path) {
        return (
            <ListItem
                button
                className={customClassName}
                onClick={onClick}
                style={{
                    padding: '8px 5px 8px 8px',
                }}
            >
                {children}
            </ListItem>
        );
    }

    // Return a LitItem with a link component
    return (
        <ListItem button className={customClassName}>
            <NavLink to={path}>{children}</NavLink>
        </ListItem>
    );
};

export default AppMenuItemComponent;
